import { useQuery } from "@tanstack/react-query";
import { get } from "../services/api";
import { getTenantPreviewSlug } from "../utils/tenantPreview";

export function usePublicPageContent(slug, options = {}) {
  const tenantPreviewSlug = getTenantPreviewSlug();
  const normalizedSlug = `${slug || ""}`.trim().toLowerCase();

  return useQuery({
    queryKey: ["public-page-content", tenantPreviewSlug, normalizedSlug],
    queryFn: async () => {
      const response = await get(`/api/v1/pages/${encodeURIComponent(normalizedSlug)}`);
      return response?.data?.page || null;
    },
    enabled: Boolean(normalizedSlug) && options.enabled !== false,
    staleTime: options.staleTime ?? 5 * 60 * 1000,
    retry: options.retry ?? 1,
  });
}
